module.exports = __webpack_public_path__ + "static/pink-rectangle-b89144a7d62153f4b46c452d3c8c18e7.png";